module.exports = __webpack_public_path__ + "img/c2-bg.d8ebcef6.jpg";